/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Save_SuccessInputs */

const vi_smartlab_settings_save_success = /** @type {(inputs: Smartlab_Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu cấu hình SmartLab`)
};

/**

* @param {Smartlab_Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_save_success = /** @type {((inputs?: Smartlab_Settings_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_save_success(inputs)
});